const protectedRoutes = [
  `.*\/account.*`,
  `.*\/datasets.*`,
  `.*\/import.*`,
  `.*\/import_for_dataset.*`,
  `.*\/sequence_for_dataset.*`,
  `.*\/explore.*`,
  `.*\/analyze.*`,
  `.*\/working_groups.*`,
];

export const isAuthenticated = (session: any) => {
  return session && session.accessTokenExpires > Date.now();
};
export const isRouteMatch = (requestUrl: string) => {
  return (
    protectedRoutes.findIndex((route) => new RegExp(route).test(requestUrl)) >
    -1
  );
};
